import { atom } from 'jotai';

// 選択された保険会社の情報を保持するアトム
export const selectedInsuranceCompaniesAtom = atom([]);

// 保険会社選択情報のアクセサとセッター
export const useInsuranceCompanies = () => {
  // 必要に応じてここにカスタムロジックを追加
  return { selectedInsuranceCompaniesAtom };
};